import { render, staticRenderFns } from "./IncreasePrices.vue?vue&type=template&id=4dbfc2c0&scoped=true"
import script from "./IncreasePrices.vue?vue&type=script&lang=js"
export * from "./IncreasePrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbfc2c0",
  null
  
)

export default component.exports